import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Tytuł',
      placeholder: 'Wprowadź tytuł powiadomienia',
    },
    body: {
      label: 'Treść wiadomości',
      placeholder: 'Wprowadź wiadomość',
    },
    promo_code: {
      label: 'Kod promocyjny',
      placeholder: 'Wybierz kod promocyjny',
    },
    offers: {
      label: 'Oferty',
      placeholder: 'Wybierz ofertę',
    },
    campaign_type: {
      label: 'Typ kampanii',
      placeholder: 'Wybierz typ kampanii',
    },
    tone: {
      label: 'Ton komunikacji',
      placeholder: 'Wybierz ton',
    },
  },
  attachment: {
    heading: 'Co powinna promować ta kampania?',
    offer: {
      title: 'Oferta',
      description: 'Wybierz spośród aktywnych ofert.',
    },
    promo_code: {
      title: 'Kod promocyjny',
      description: 'Wybierz spośród aktywnych kodów promocyjnych.',
    },
  },
  buttons: {
    generate: 'Generuj',
    improve: 'Ulepsz z AI',
    undo: 'Cofnij ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Przyjazny 🙂',
    [ToneTypes.Elegant]: 'Elegancki ✨',
    [ToneTypes.Playful]: 'Zabawny 🎉',
    [ToneTypes.Professional]: 'Profesjonalny 👨‍💼',
    [ToneTypes.Informative]: 'Informacyjny 📊',
    [ToneTypes.Persuasive]: 'Przekonujący 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Promocyjny 🚀',
    [CampaignTypes.Informational]: 'Informacyjny ℹ️',
  },
  no_promo_codes: {
    title: 'Brak kwalifikujących się kodów promo',
    description: 'Utwórz nowy kod promo.',
    create_promo_code: 'Utwórz kod promo',
  },
  no_offers: {
    title: 'Brak aktywnych ofert',
    description: 'Utwórz nową ofertę.',
    create_offer: 'Utwórz ofertę',
  },
  feedback: {
    success: 'Wygenerowano pomyślnie',
    error: 'Generowanie nie powiodło się',
  },
};
